export default "__VITE_ASSET__f33dad48__"